var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('EvalInProgress', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress
    },
    on: {
      "massAssignation": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "showPreview": function ($event) {
        _vm.showPreview = true;
      }
    }
  }), _vm._v(" "), _c('mass-template-assignation', {
    attrs: {
      "opened": _vm.massAssignation,
      "template": _vm.massAssignationTemplate
    },
    on: {
      "close": function ($event) {
        _vm.massAssignation = false;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.confirmDeleteTemplate > -1
    },
    on: {
      "close": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }, [_vm.confirmDeleteTemplate == 0 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer la page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.confirm_delete_template
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 1 ? _c('div', [_c('h3', {
    staticClass: "w-full text-indigo-600 mt-12 mb-10"
  }, [_vm._v("\n        Le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\""), _c('br'), _vm._v("a bien été\n        supprimé !\n      ")]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 2 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            Attention, ce modèle de page est utilisé par\n            " + _vm._s(_vm.listAssignedUsersTemplate.length) + " bénéficiaire"), _vm.listAssignedUsersTemplate.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n            :\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, _vm._l(_vm.listAssignedUsersTemplate, function (beneficiary, index) {
    return _c('span', {
      key: beneficiary.id
    }, [index > 0 ? _c('span', [_vm._v("- ")]) : _vm._e(), _vm._v(_vm._s(beneficiary.firstname) + " "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(beneficiary.lastname))])]);
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            En cas de suppression, le modèle de page \"" + _vm._s(_vm.templatePageToAssignAfterDelete.name) + "\" leur sera attribué.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirm_delete_template(_vm.templatePageToAssignAfterDelete);
      }
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('deactivate-template-popup', {
    attrs: {
      "confirm-deactivate-template": _vm.confirmDeactivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate,
      "list-assigned-users-template": _vm.listAssignedUsersTemplate,
      "template-page-to-assign-after-delete": _vm.templatePageToAssignAfterDelete
    },
    on: {
      "confirm_deactivate_template": function (templatePageToAssignAfterDelete) {
        _vm.confirm_deactivate_template(templatePageToAssignAfterDelete);
      },
      "close": function ($event) {
        _vm.confirmDeactivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('activate-template-popup', {
    attrs: {
      "confirm-activate-template": _vm.confirmActivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate
    },
    on: {
      "confirm_activate_template": function ($event) {
        return _vm.confirm_activate_template();
      },
      "close": function ($event) {
        _vm.confirmActivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.showPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }, [_c('div', [_c('h3', {
    staticClass: "mt-15 mb-15 w-full"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPage.libelle_template) + "\n      ")]), _vm._v(" "), _vm.activities && _vm.activities.length > 0 ? _c('list-grid', {
    attrs: {
      "list-items": _vm.activities,
      "is-accordion-items": ""
    },
    on: {
      "displayNum": function (index) {
        _vm.itemDisplayed = index;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-2 col-span-3"
        }, [_vm._v("\n            Activité\n          ")]), _vm._v(" "), _vm.template[2].included ? _c('div', {
          staticClass: "col-span-4"
        }, [_vm._v("\n            Niveau de maîtrise\n          ")]) : _vm._e(), _vm._v(" "), _vm.template[0].included ? _c('div', {
          staticClass: "col-span-4"
        }, [_vm._v("\n            Temps consacré\n          ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-span-1 place-self-center"
        }, [_c('icon', {
          staticClass: "text-pink-600 transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.itemDisplayed === num
          },
          attrs: {
            "name": "chevron-right"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 text-base font-normal"
        }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm.template[2].included ? _c('div', {
          staticClass: "col-span-4 text-base font-normal"
        }, [item.lvl !== '' || item.lvl !== undefined || item.lvl !== null ? _c('span', [_vm._v("\n              " + _vm._s(item.lvl) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.template[0].included ? _c('div', {
          staticClass: "col-span-4 text-base italic font-normal"
        }, [item.time !== '' || item.time !== undefined || item.time !== null ? _c('span', [_vm._v("\n              " + _vm._s(item.time) + "\n            ")]) : _vm._e()]) : _vm._e()];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "grid grid-cols-12 md:space-x-3"
        }, [_vm._l(['time', 'lvl', 'requis', 'evo'], function (general, i) {
          return _c('div', {
            key: `general${i}`,
            staticClass: "col-span-full md:col-span-3"
          }, [_vm.template[i].included ? _c('input-select', {
            attrs: {
              "name": _vm.template[i].libelle + num,
              "libelle": _vm.template[i].libelle,
              "value": item[general],
              "datas": _vm.template[i].criterions
            }
          }) : _vm._e()], 1);
        }), _vm._v(" "), _vm._l([{
          title: 'Tâches Principales',
          name: 'Tâche',
          accessor: 'tasks'
        }, {
          title: 'Pratiques Professionnelles',
          name: 'Pratique',
          accessor: 'pratiques_pro'
        }, {
          title: 'Connaissances associées',
          name: 'Connaissance',
          accessor: 'activity_connaissances'
        }, {
          title: 'Comportement / Attitudes',
          name: 'Comportement',
          accessor: 'activity_comportement'
        }], function (subTask, subTaskIndex) {
          return [_c('div', {
            key: `subTaskTitle${subTaskIndex}`,
            staticClass: "col-span-full uppercase text-indigo-600 text-base my-5"
          }, [_vm._v("\n                " + _vm._s(subTask.title) + "\n              ")]), _vm._v(" "), item[subTask.accessor] && item[subTask.accessor].length > 0 ? _c('list-grid', {
            key: `subTask${subTaskIndex}`,
            staticClass: "col-span-full",
            attrs: {
              "grid": "grid-cols-11",
              "list-items": item[subTask.accessor]
            },
            scopedSlots: _vm._u([{
              key: "header",
              fn: function () {
                return [_c('div', {
                  staticClass: "ml-2 md:ml-10 col-span-4"
                }, [_vm._v("\n                    " + _vm._s(subTask.name) + "\n                  ")]), _vm._v(" "), _c('div', {
                  staticClass: "col-span-2 hidden md:inline"
                }, [_vm._v("\n                    Auto-évaluation\n                  ")]), _vm._v(" "), _c('div', {
                  staticClass: "col-span-2 hidden md:inline"
                }, [_vm._v("\n                    Dernière eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
                  staticClass: "col-span-2 hidden md:inline"
                }, [_vm._v("\n                    Nouvelle eval. ref.\n                  ")]), _vm._v(" "), _c('div', {
                  staticClass: "col-span-5 md:hidden"
                }, [_vm._v("\n                    Evaluations\n                  ")]), _vm._v(" "), _c('div', {
                  staticClass: "col-span-1 text-center"
                }, [_vm._v("\n                    Comm.\n                  ")])];
              },
              proxy: true
            }, {
              key: "accordionDescription",
              fn: function (_ref3) {
                var _vm$template$4$criter, _vm$template$4$criter2;
                var subItem = _ref3.item,
                  subItemNum = _ref3.subItemNum;
                return [_c('div', {
                  staticClass: "row-start-1 row-span-3 md:row-span-1 col-span-4 text-sm ml-2 md: ml-10"
                }, [_vm._v("\n                    " + _vm._s(subItem.name) + "\n                  ")]), _vm._v(" "), _c('input-text', {
                  staticClass: "col-start-5 col-span-4 row-start-1 md:row-start-auto md:col-span-2",
                  attrs: {
                    "libelle": "",
                    "value": (_vm$template$4$criter = _vm.template[4].criterions[Math.floor(Math.random() * _vm.template[4].criterions.length)]) === null || _vm$template$4$criter === void 0 ? void 0 : _vm$template$4$criter.value,
                    "disabled": true
                  }
                }), _vm._v(" "), _c('input-text', {
                  staticClass: "col-start-5 col-span-4 row-start-2 md:row-start-auto md:col-span-2",
                  attrs: {
                    "libelle": "",
                    "value": (_vm$template$4$criter2 = _vm.template[4].criterions[Math.floor(Math.random() * _vm.template[4].criterions.length)]) === null || _vm$template$4$criter2 === void 0 ? void 0 : _vm$template$4$criter2.value,
                    "disabled": true
                  }
                }), _vm._v(" "), _c('input-select', {
                  staticClass: "col-start-5 col-span-4 row-start-3 md:row-start-auto md:col-span-2",
                  attrs: {
                    "libelle": "",
                    "name": `${subItemNum}${num}${subTask.accessor}${subItem.name}`,
                    "value": subItem.auto,
                    "datas": _vm.template[4].criterions
                  }
                }), _vm._v(" "), _c('icon-comment', {
                  staticClass: "col-span-1 row-start-2 md:row-start-auto place-self-center",
                  attrs: {
                    "name": `comment-${num}-${subItem.name}-${subItemNum}`
                  }
                })];
              }
            }], null, true)
          }) : _vm._e()];
        })], 2)];
      }
    }], null, false, 3732454379)
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.isEditable ? _c('div', [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('input-title', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20 w-3/4",
    attrs: {
      "name": "title",
      "value": _vm.infosPage.libelle_template,
      "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) || this.evaluationInProgress,
      "error": true,
      "maxlength": 40
    },
    on: {
      "input": function (value) {
        _vm.infosPage.libelle_template = value;
      },
      "valid": function (title) {
        _vm.SET_NAME_TEMPLATE_IN_LIST([_vm.infosPage.id_template, title]);
      }
    }
  })], 1), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": ""
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      },
      "confirmDelete": function () {
        _vm.displayConfirmDeleteTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, _vm._l(_vm.template, function (field, index) {
    return _c('div', {
      key: index,
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-6 place-content-center mb-15"
    }, [_c('div', {
      staticClass: "col-span-full flex flex-col md:flex-row items-baseline"
    }, [_c('span', {
      staticClass: "text-gray-900 text-base uppercase mr-3"
    }, [_vm._v(_vm._s(field.libelle))]), _vm._v(" "), !field.libelle.includes('Critères') ? _c('checkbox-indigo', {
      attrs: {
        "libelle": "Inclure dans l'évaluation",
        "name": "inlude_field",
        "value": field.included
      },
      on: {
        "input": function (newValue) {
          field.included = newValue;
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _vm._l(field.criterions, function (crit, jndex) {
      return _c('div', {
        key: jndex,
        staticClass: "col-span-full lg:col-span-3 relative",
        class: {
          'col-start-1': jndex == 0
        }
      }, [_vm.evaluationInProgress ? _c('input-text', {
        attrs: {
          "libelle": "",
          "placeholder": 'Critère ' + (jndex + 1),
          "value": crit.value,
          "disabled": true
        },
        on: {
          "input": function (newValue) {
            _vm.$set(crit, 'value', newValue);
          }
        }
      }) : _c('input-text', {
        attrs: {
          "libelle": "",
          "placeholder": 'Critère ' + (jndex + 1),
          "value": crit.value,
          "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
        },
        on: {
          "input": function (newValue) {
            _vm.$set(crit, 'value', newValue);
          }
        }
      }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
        staticClass: "absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full",
        on: {
          "click": function ($event) {
            return _vm.deleteCriterion(index, jndex);
          }
        }
      }, [_c('icon', {
        staticClass: "h-2 w-2 2xl:h-2.5 2xl:w-2.5",
        attrs: {
          "name": "close"
        }
      })], 1) : _vm._e()], 1);
    }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
      staticClass: "col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium",
      on: {
        "click": function ($event) {
          return _vm.addCriterion(index);
        }
      }
    }, [_c('span', {
      staticClass: "plus-button 2xl:h-10 2xl:w-10"
    }, [_c('icon', {
      attrs: {
        "name": "plus"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
    }, [_vm._v("\n            Ajouter un critère\n          ")])]) : _vm._e()], 2);
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('h3', [_vm._v("\n        " + _vm._s(this.infosPage.libelle_template) + "\n      ")])]), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": false
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-15"
  }, [_c('h3', {
    staticClass: "text-lg text-gray-600"
  }, [_vm._v("\n        Le modèle de page " + _vm._s(this.infosPage.libelle_template) + " n'est pas\n        modifiable."), _c('br'), _vm._v("\n        Vous pouvez simplement\n        "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('span', [_vm._v("activer ou désactiver")]) : _c('span', [_vm._v("visualiser")]), _vm._v(" le modèle de page.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my-15 flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }